import * as Yup from 'yup';
import '@dfl/yup-validations';
import { ImagesScheme } from 'modules/common/schemas';

export const productDescriptionSchema = Yup.object().shape({
  description: Yup.string().required('required').min(2, 'min-2'),
});

export const productCodeSchema = Yup.object().shape({
  code: Yup.string().required('required').min(2, 'min-2'),
});

export const productGeneralInfoSchema = Yup.object().shape({
  name: Yup.string().required('required').min(2, 'min-2'),
  media: ImagesScheme,
  description: Yup.string().required('required').trim().min(4, 'min-4'),
  brand: Yup.string().required('required').min(2, 'min-2'),
  code: Yup.string().required('required').min(2, 'min-2'),
  referenceCode: Yup.string(),
  category: Yup.string()
    .transform((a) => a?._id || a)
    .required('required'),
  otherCategories: Yup.array()
    .of(Yup.string().transform((a) => a?._id || a))
    .max(5, 'max-5')
    .default([]),
});
